import { PartInfo } from "../partinfo";

export class UpdateHotRequestDTO {
    PartInfoList: PartInfo[];
    HotRequestStatus: boolean;
    constructor() {}
}
